export default "__VITE_ASSET__BNEeKFSM__"